var map = {
	"./avatar.png": "4d41",
	"./cyberboard.gif": "9b36",
	"./cyberboard_r1.jpg": "6691",
	"./cyberboard_r2.jpg": "c83a",
	"./device_65les.png": "91125",
	"./device_65les_r1.png": "e190",
	"./device_65les_r2.png": "af38",
	"./device_alice.png": "d344",
	"./device_am21.png": "573b",
	"./device_am28.png": "ea0f",
	"./device_am_28.png": "c061",
	"./device_cb01.png": "6b89",
	"./device_cb02.png": "992f",
	"./device_cb03.png": "bf30",
	"./device_cb04.png": "73e0",
	"./device_cb_matrix.png": "fada",
	"./device_cb_terminal.png": "e94e",
	"./device_cyberblade.png": "7de2",
	"./device_dongle.png": "c08c",
	"./device_dr001.png": "973c",
	"./device_dr002.png": "a5e3",
	"./device_hatsu.png": "6639",
	"./device_mouse.png": "dfdd",
	"./device_mousedongle.png": "ab60",
	"./download_r1.jpg": "1ca3",
	"./download_r2.jpg": "cca1",
	"./icon_battery.svg": "6388",
	"./icon_cn.svg": "9e36",
	"./icon_dongle.svg": "ea99",
	"./icon_dongle_active.svg": "fd53",
	"./icon_dpi.svg": "e9db",
	"./icon_dpi_active.svg": "a3c8",
	"./icon_en.svg": "8567",
	"./icon_firmware.svg": "63b7",
	"./icon_firmware_active.svg": "b403",
	"./icon_info.svg": "18d4",
	"./icon_keyboard.svg": "132c",
	"./icon_keyboard_active.svg": "a9f0",
	"./icon_macro.svg": "34a2",
	"./icon_macro_active.svg": "5a43",
	"./icon_menu.svg": "465e",
	"./icon_mouse.svg": "0a63",
	"./icon_mouse_active.svg": "cbda",
	"./icon_new.png": "34e1",
	"./icon_new_red.svg": "3e68",
	"./icon_next.svg": "8b5c",
	"./icon_param.svg": "8738",
	"./icon_param_active.svg": "78f6",
	"./icon_transport.svg": "d6b5",
	"./icon_transport_active.svg": "2f4f",
	"./icon_turn.svg": "701f",
	"./index_keyboard_border.png": "7a60",
	"./index_light_border.png": "ea1e",
	"./keyboard_65_fluffy.png": "9033",
	"./keyboard_65_game_boy.png": "8788",
	"./keyboard_65_less.png": "9172",
	"./keyboard_65_less_split.png": "b7a5",
	"./keyboard_75.png": "c4e3",
	"./keyboard_80.png": "58f2",
	"./keyboard_80_no_led.png": "0c07",
	"./keyboard_alice.png": "777b",
	"./keyboard_hatsu.png": "717e",
	"./keyboard_r1.png": "eedb",
	"./keyboard_r2.png": "a6e7",
	"./lang_cn.svg": "316c",
	"./lang_en.svg": "61fe",
	"./lang_ja.svg": "e5080",
	"./led_in_switch.png": "169a",
	"./led_in_switch_65_fluffy.png": "c4b6",
	"./led_in_switch_65_game_boy.png": "d0c3",
	"./led_in_switch_65_less.png": "81ba",
	"./led_in_switch_75.png": "6da1",
	"./led_in_switch_80.png": "01d0",
	"./led_in_switch_80_no_led.png": "e5c2",
	"./led_in_switch_alice.png": "113f",
	"./led_strip_r1.png": "b751",
	"./led_strip_r2.png": "2618",
	"./led_strip_rgb_65.png": "9e87",
	"./logo.svg": "e347",
	"./logo_square.png": "c670",
	"./logo_white.png": "5ffc",
	"./mouse.png": "dad8",
	"./nowire.svg": "bb30",
	"./qrcode_qq.png": "79a5",
	"./updated_cyberblade.gif": "f2b9",
	"./updated_keyboard.png": "24db",
	"./welcome.gif": "282d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e5b";